import React, { Component } from "react";
import { Modal, Header, Input } from "semantic-ui-react";
import "./ScanShippingLabelModal.css";
import SharedFunctions from "../../utils/SharedFunctions";
import { SCAN_SHIPPING_LABEL_MODAL } from "../../utils/constants/componentConstants";
import { SERVICES_BASE_URL } from "../../utils/Constants";

class ScanShippingLabelModal extends Component {
  constructor() {
    super();
    this.state = {
      enteredPackageNumber: "",
      scanValue: "",
      showError: false,
    };
  }

  _shippingLabelsTheSame(input, printedLabel) {
    var inputUpperCase = (input || "").toUpperCase();
    var printedLabelUpperCase = (printedLabel || "").toUpperCase();

    var inputIsLabel = inputUpperCase === printedLabelUpperCase;
    var inputContainsLabel = inputUpperCase.indexOf(printedLabelUpperCase) > -1;
    var isBussgodsMatch =
      (printedLabelUpperCase.substr(0, 3) === "BUS" &&
        printedLabelUpperCase.substr(3) === inputUpperCase) ||
      (inputUpperCase.substr(0, 3) === "BUS" && inputUpperCase.substr(3) === printedLabelUpperCase);
    var isSchenkerMatch =
      inputUpperCase.length + 1 === printedLabelUpperCase.length &&
      printedLabelUpperCase.indexOf(inputUpperCase) > -1;

    return [inputIsLabel, inputContainsLabel, isBussgodsMatch, isSchenkerMatch].some((x) => x);
  }

  //Set focus on input
  handleRef = (c) => {
    this.inputRef = c;
  };
  setInputFocus = () => {
    if (this.inputRef && this.inputRef.focus) {
      this.inputRef.focus();
    }
  };

  componentDidMount() {
    SharedFunctions.LogPopupShownEvent(SCAN_SHIPPING_LABEL_MODAL);
    this.setInputFocus();
  }

  componentDidUpdate() {
    this.setInputFocus();
  }

  //Track state from input box
  handleInputChange = (e) => {
    this.setState({
      scanValue: e.target.value,
    });
  };

  //Detect submit
  onInputKeyPress(e) {
    if (e.key === "Enter") {
      this.submitPackageCode();
    }
  }

  //Submit and verify code
  submitPackageCode() {
    if (this._shippingLabelsTheSame(this.state.scanValue, this.props.packageNumber)) {
      this.setState({
        showError: false,
        scanValue: "",
      });
      this.props.onClose();
    } else {
      this.setState({
        showError: true,
        scanValue: "",
      });
    }
  }

  render() {
    const { open } = this.props;
    let { orderInfo } = this.props;
    orderInfo = orderInfo || {};

    let errorMessage = (
      <div className="ui negative message">
        <div className="header">Felaktigt scannad fraktetikett</div>
        <p>Fraktetiketten stämmer inte med ordern.</p>
      </div>
    );

    return (
      <div className={"ModalWrapper"} onClick={() => this.inputRef.focus()}>
        <Modal
          open={open}
          className="ScanShippingLabelModal"
          size="small"
          closeOnEscape={false}
          closeOnDimmerClick={false}
        >
          <Header>
            <Header.Content>
              <h2>Verifiera fraktetikett</h2>
            </Header.Content>
          </Header>
          <Modal.Content>
            <div style={{ verticalAlign: "top" }}>
              <img
                src={`${SERVICES_BASE_URL}/images/logo-rx.png`}
                className={"rx-logo"}
                alt="RXlogo"
              />

              <div
                style={{ display: "inline-block", borderLeft: "solid 2px", paddingLeft: "10px" }}
              >
                <div className="Subtitle">
                  Paketet innehåller RX.
                  <br />
                  Fraktetiketten måste scannas.
                </div>

                <div className={"info-box"}>
                  <h3>Fraktinfo</h3>
                  <div className={"customer-name"}>{orderInfo.customerName}</div>
                  <div className={"customer-street"}>{orderInfo.street}</div>
                  <div className={"customer-city"}>{orderInfo.zip + " " + orderInfo.city}</div>
                  <div className={"shipping-info"}>
                    {orderInfo.shippingMethodText}
                    <img
                      src={
                        `${SERVICES_BASE_URL}/Images/shipping-method/large/` +
                        orderInfo.shippingMethod +
                        ".png"
                      }
                      alt={orderInfo.shippingMethod}
                    />
                  </div>
                </div>

                <Input
                  ref={this.handleRef}
                  placeholder="Scanna fraktetikett"
                  value={this.state.scanValue}
                  onChange={this.handleInputChange}
                  onKeyPress={(e) => this.onInputKeyPress(e)}
                />
              </div>
              {this.state.showError && errorMessage}
            </div>
          </Modal.Content>
        </Modal>
      </div>
    );
  }
}

export default ScanShippingLabelModal;
